export class TaxpayerCertificate {
  front: string;
}
